export default __webpack_public_path__ + "static/media/gallery_10.0ab1a624.jpg";